import React, { Suspense, useEffect, useState } from "react";
import Paper from '@mui/material/Paper';
import Loading from 'components/common/Loading';
import { i18Intl } from "../../utils";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  selectData,
  selectThinfinityTittle,
  selectThinfinityVisibility
} from "../../features/thinfinity/thinfinitySelector";
import { setThinfinityVisivility } from '../../features/thinfinity/thinfinitySlice';
import { HeaderContainer, ThinfinityContainer, ThinfinityDialogContainer } from './styled';
import { useHistory } from "react-router-dom";
import { selectReport } from "../../features/userDetail/userDetailSelector";
import { postReportAsync } from "../../features/userDetail/asyncActions";
import { ModalCloseButton } from 'components/common/ModalTitle';

const Thinfinity = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const hidden = useAppSelector(selectThinfinityVisibility);
  const tittle = useAppSelector(selectThinfinityTittle);
  const data = useAppSelector(selectData);

  const { data: dataReport, status } = useAppSelector(selectReport);
  const [activeReport, setActiveReport] = useState(false);

  useEffect(() => {}, [tittle, hidden]);

  useEffect(() => {
    sendMessageToApp();
  }, [data]);

  const getUrl = () => {
    return 'https://thinfinity.telemedcare.com/RemoteApp/';
  };

  function sendMessageToApp() {
    let frame = document.getElementById('iframe');

    console.log('Data sent: ', data);

    // @ts-ignore
    if (frame && frame.contentWindow) {
      // @ts-ignore
      frame.contentWindow.postMessage(data, getUrl());
    }
  }

  useEffect(() => {
    if (dataReport?.filename && activeReport) {
      const link = document.createElement('a');
      link.href = dataReport.filename;
      link.download = `health_user_report.pdf`;
      link.click();
      setActiveReport(false);
    }
  }, [dataReport])

  window.addEventListener('message', function (event) {

    if (!event.data) return; // Ignorar eventos sin datos

    const { message, jsonObject } = event.data;

    //console.log('Received message: ', event.data);

    if (message === 'sendUserId') {
      sendMessageToApp();
    }

    if (jsonObject !== null && jsonObject !== undefined) {

      const obj = JSON.parse(jsonObject);

      if (obj.eventType === 'gotoUserId'){
        history.push(`/patient/${obj.userId}`);
        handleClose();
      }

      if (obj.eventType === 'userReport'){

        const test = {
          userId: obj.userId,
          from: obj.from,
          to: obj.to,
          measureSystem: obj.measureSystem,
          firstName: obj.firstName ,
          middleName: obj.middleName,
          lastName: obj.lastName ,
        }

        handleReport(test);
      }
    }
  });

  const handleReport = (data: any) => {

    if (data.from < data.to) {
      setActiveReport(true);
      const dataReport = {
        reportName: "health_user_report",
        format: "pdf",
        userId: data.userId,
        dateStart: data.from,
        dateEnd: data.to,
        locale: "en_US",
        systemUnit: data.measureSystem,
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      dispatch(postReportAsync(dataReport));
    }
  }

  const handleClose = () => {
    dispatch(setThinfinityVisivility(true));
  };

  function getDisplay() {
    if (hidden) {
      return 'none';
    } else {
      return 'flex';
    }
  }

  return (
    <ThinfinityDialogContainer style={{ display: getDisplay() }}>
      <ThinfinityContainer>
        <HeaderContainer>
          {tittle && <h4>{i18Intl('thinfinity.' + tittle)}</h4>}
          <ModalCloseButton onClose={handleClose} />
        </HeaderContainer>

        <Suspense fallback={<Loading />}>
          <Paper sx={{ width: '100%', height: '100%', marginBottom: '5px', overflow: 'hidden' }}>
            <div style={{ width: '100%', height: '100%' }}>
              <iframe
                id={'iframe'}
                style={{ border: 'none', height: '100%' }}
                src={getUrl()}
                width="100%"
                height="720px"
              />
            </div>
          </Paper>
        </Suspense>
      </ThinfinityContainer>
    </ThinfinityDialogContainer>
  );
};

export default Thinfinity;
